module.exports = __webpack_public_path__ + "assets/img/logo_bitwallet.7fca515b.svg";